import {Dispatch} from 'redux';
import {ErrorDto} from '../../../models/dtos/error.dto';
import {HashDetailDto} from '../../../models/dtos/hashDetail.dto';
import {Errors} from '../../../utilities/errors';
import {GET_HASH_FAIL, GET_HASH_RESET, GET_HASH_START, GET_HASH_SUCCESS} from './constants';
import {getHashRequest} from "./repository";
import {GetHashFailAction, GetHashResetAction, GetHashStartAction, GetHashSuccessAction} from './types';

const getHashStartAction = (): GetHashStartAction => {
  return {
    type: GET_HASH_START,
  };
};
const getHashSuccessAction = (payload: HashDetailDto): GetHashSuccessAction => {
  return {
    type: GET_HASH_SUCCESS,
    payload: payload,
  };
};
const getHashFailAction = (error: ErrorDto): GetHashFailAction => {
  return {
    type: GET_HASH_FAIL,
    error: error,
  };
};
const getHashResetAction = (): GetHashResetAction => {
  return {
    type: GET_HASH_RESET,
  };
};

export const getHash = (hash: string) => async (dispatch: Dispatch) => {
  try {
    dispatch(getHashStartAction());
    const response = await getHashRequest(hash);
    dispatch(getHashSuccessAction(response));
  } catch (error) {
    dispatch(getHashFailAction(Errors.getErrorDtoFromApiError(error)));
  }
};

export const getHashReset = () => (dispatch: Dispatch) => {
  dispatch(getHashResetAction());
};
